import UdeskLocales from 'UdeskLocales';
import React, { forwardRef } from 'react';
import { Badge, Space } from 'udesk-ui';
import { ContentHeader, RoleTag } from './components';

interface TemplateProps {
    item?: any;
    content?: any;
    titleRef?: any;
}

const Template = forwardRef((props: TemplateProps, ref: any) => {
    const { item, content, titleRef } = props;

    const locales = UdeskLocales['current'];

    const { data = {} } = item;

    return (
        <div>
            <ContentHeader>
                <Space>
                    <div style={{ fontWeight: 600 }}>{data.sendUser}</div>
                    <RoleTag sender={data.sender}>
                        {data.sender === 1 || data.sender === '1'
                            ? /* 客户 */ locales.components.ticketTextInfo.index.customer
                            : /* 客服 */ locales.components.ticketTextInfo.index.customerService}
                    </RoleTag>
                </Space>

                <div className="desc" ref={titleRef}>
                    {`${data.createdTime}${/* 发起外呼 */UdeskLocales['current'].components.ticketTextInfo.components.call.index.initiateOutcall}`}
                </div>
            </ContentHeader>

            <div style={{ marginBottom: 16 }}>
                <div>{/* 通话信息： */}{UdeskLocales['current'].components.ticketTextInfo.components.call.index.callInformation}</div>
                <div>
                    <Space wrap>
                        <Badge status="default" text={`${/* 分配号码： */UdeskLocales['current'].components.ticketTextInfo.components.call.index.assignedNumber}${data.dialNumber || '-'}`} />
                        <Badge status="default" text={`${/* 分配客服： */UdeskLocales['current'].components.ticketTextInfo.components.call.index.assignAgent}${data.assignAgent || '-'}`} />
                        <Badge status="default" text={`${/* 接听延时： */UdeskLocales['current'].components.ticketTextInfo.components.call.index.answerDelay}${data.answerDelay || '-'}`} />
                        <Badge status="default" text={`${/* 接听号码： */UdeskLocales['current'].components.ticketTextInfo.components.call.index.answerNumber}${data.answerNumber || '-'}`} />
                        <Badge status="default" text={`${/* 呼叫模式： */UdeskLocales['current'].components.ticketTextInfo.components.call.index.callMode}${data.callMode || '-'}`} />
                        <Badge status="default" text={`${/* 状态： */UdeskLocales['current'].components.ticketTextInfo.components.call.index.status}${data.callStatus || '-'}`} />
                        <Badge status="default" text={`${/* 通话时长： */UdeskLocales['current'].components.ticketTextInfo.components.call.index.callDuration}${data.callDuration || '-'}`} />
                    </Space>
                </div>
            </div>

            {content ? (
                <div>
                    <audio controls src={content} style={{ marginBottom: 16, width: '100%' }}>{/* 您的浏览器不支持 audio 元素。 */}{UdeskLocales['current'].components.ticketTextInfo.components.call.index.yourBrowserDoesNotSupportTheAudioElement}</audio>
                </div>
            ) : null}
        </div>
    );
});

export default Template;
